import { render, staticRenderFns } from "./AddProductionSheetItemModal.vue?vue&type=template&id=8f5becfa&scoped=true"
import script from "./AddProductionSheetItemModal.vue?vue&type=script&lang=js"
export * from "./AddProductionSheetItemModal.vue?vue&type=script&lang=js"
import style0 from "./AddProductionSheetItemModal.vue?vue&type=style&index=0&id=8f5becfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5becfa",
  null
  
)

export default component.exports